/* lua.js generated code 0.3.0 */

var ServiceButton = xClass("ServiceButton", function () {
    return cc.CSLoader.createNode("cocos/homeScene_faq_btn.csb")
})
ServiceButton.prototype.ctor = function (type) {
    let self = this
    self.type = type || 1
    self.init()
}
ServiceButton.prototype.init = function () {
    var self = this
    let bg = self.getChildByName("bg")
    // bg.setVisible(false)
    // bg.setSpriteFrame(--------)
    // bg.y = 35
    var btn = UIButton.create(bg, true)
    btn.on(UIButtonEvent.Click, handler(self, self.onOpenFC))
    self.btn = btn
    self.btn.nodeExist = true
}
ServiceButton.prototype.onOpenFC = function () {
    var self = this
    self.btn.setEnabled(false)
    self.runAction(cc.Sequence.create(cc.DelayTime.create(2), cc.CallFunc.create(function () {
        if (self.btn.nodeExist) {
            self.btn.setEnabled(true)
        }
    })))
    function onFail() {
        Toast.make("打开社区错误，请重试！")
    }
    let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
    // (pf == "qq_lightgame"
    if (META.platform == XcloverPlatform.wechatgame) {
        if(mini.openCustomerServiceConversation) {
            mini.openCustomerServiceConversation();
        }else if (pf == "qq_lightgame"){
            let CustomeServicePanel = require("clover/scene/component/homescene/CustomeService/CustomeServicePanel")
            CustomeServicePanel.show()
        } else {
            Toast.make("您的App版本过低，请升级后重试");
        }
    }else {
        switch (self.type) {
            case 1:
                OpenFunscareLogic.openFunscare(1, null, null, onFail)
                break;
            case 2:
                OpenFunscareLogic.openForum(0, null, null, onFail)
            default:
                break;
        }
    }
    DCAssist.dc4OpenModule(ModuleName.FAQ)
}
// ServiceButton.create = function () {
//     var __VA_ARG = $slice(arguments, 0)
//     var self = this
//     var instance = ServiceButton.new()
//     assert(instance)
//     if (instance) {
//         instance.init()
//     }
//     return instance
// }
module.exports = ServiceButton
